import React from "react";

import { SelectInput, useTranslate, ReferenceInput } from "react-admin";
import Typography from "@material-ui/core/Typography";

/**
 * Liste des hôtels
 * @todo use referencefield and use hotels from GMC ?
 * @param {Object} props
 */
const HotelInput = ({ emptyText, visibleFor, ...props }) => {
    const translate = useTranslate();
    // Filtre de disponibilité selon le contexte (front/back-office)
    const availabilityFilter =
        visibleFor === "front"
            ? { "Dispo Chevalier": true }
            : visibleFor === "back"
            ? { "Dispo back-office": true }
            : {};

    // Intégrer un éventuel filtre passé par le parent
    const externalFilter =
        props.filter && Object.keys(props.filter).length ? props.filter : null;

    // Construction du filtre final: uniquement disponibilité + filtre parent éventuel
    const combinedFilter = (() => {
        const andParts = [];
        if (availabilityFilter && Object.keys(availabilityFilter).length) {
            andParts.push(availabilityFilter);
        }
        if (externalFilter) {
            andParts.push(externalFilter);
        }
        if (andParts.length === 0) return {};
        return andParts.length === 1 ? andParts[0] : { "{{Op.and}}": andParts };
    })();
    return (
        <ReferenceInput
            allowEmpty
            reference="hotel"
            filter={combinedFilter}
            sort={{
                field: "Ville",
                order: "ASC",
            }}
            perPage={1000}
            {...props}
        >
            <SelectInput
                optionText={(hotel) =>
                    hotel ? (
                        <div>
                            {hotel["Ville"] ? (
                                <>
                                    <Typography variant="caption">
                                        {hotel["Ville"]}
                                    </Typography>
                                    {" - "}
                                </>
                            ) : null}
                            {hotel["Adresse 1"]}
                        </div>
                    ) : null
                }
                emptyText={translate(emptyText)}
            />
        </ReferenceInput>
    );
};

export default HotelInput;
